module.exports = __webpack_public_path__ + "img/dianjiyun1.5eca05a4.png";